// extracted by mini-css-extract-plugin
export default {"base":"o_VwWg","error":"NVKv31","message":"AnbT7Y"};